theme.Currency = (function () {
  var moneyFormat = "$"; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ",";
      decimal = decimal || ".";

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney,
  };
})();


if (typeof WDN === 'undefined') {
  var WDN = {};
}

if (typeof WDN.Money === 'undefined') {
  WDN.Money = (function () {
    var FormatMoney = function (price) {
      
      var priceFactor = 1;
      
      if (theme.isB2b) {
        priceFactor = 2.5;
      }
      
      return theme.Currency.formatMoney(price / priceFactor, theme.moneyFormat);
    };

    return {
      Format: FormatMoney,
    };
  })();
}

if (typeof WDN.Request === "undefined") {
  WDN.Request = (function () {
    // Private function
    var _do;

    // Public function
    var Get, Post;

    _do = function (obj) {
      var req = new XMLHttpRequest();
      if (obj.method == "POST" || obj.method == "PUT") {
        req.open(obj.method, obj.url);
        req.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      }
      req.onreadystatechange = function () {
        if (req.status == 200) {
          if (req.readyState == 4 && obj.onSuccess) {
            obj.onSuccess(req.responseText);
          }
        } else if (req.status == 404 || req.status == 400) {
          if (obj.onError) {
            obj.onError(req.responseText);
          }
        }
      };

      if (obj.method == "POST" || obj.method == "PUT") {
        req.send(JSON.stringify(obj.data));
      } else {
        req.open("GET", obj.url, true);
        req.send(null);
      }
    };

    Get = function (obj) {
      _do({
        method: "GET",
        url: obj.url,
        onSuccess: function (res) {
          obj.type == "JSON"
            ? obj.onSuccess(JSON.parse(res))
            : obj.onSuccess(res);
        },
        onError: function (res) {
          obj.type == "JSON" ? obj.onError(JSON.parse(res)) : obj.onError(res);
        },
      });
    };

    Post = function (obj) {
      _do({
        method: "POST",
        url: obj.url,
        data: obj.data,
        onSuccess: function (res) {
          obj.onSuccess(JSON.parse(res));
        },
        onError: function (res) {
          obj.onError(res);
        },
      });
    };

    return {
      Get: Get,
      Post: Post,
    };
  })();
}

if (typeof WDN.Cart === "undefined") {
  WDN.Cart = (function () {
    // Include WDN.Request
    var Request = WDN.Request;

    if (!Request) {
      console.warn("Could not include WDN.Cart. WDN.Request was not found");
      return false;
    }

    // Public
    var Add, Update, Change, Get, Remove, Clear;

    // Private helpers
    var isFunction;

    isFunction = function (func) {
      return typeof func === "function";
    };

    var Routes = {
      add: "/cart/add.js",
      get: "/cart.js",
      update: "/cart/update.js",
      clear: "/cart/clear.js",
      change: "/cart/change.js",
    };

    Get = function (obj) {
      Request.Get({
        url: Routes.get,
        onSuccess: function (res) {
          if (isFunction(obj.onSuccess)) {
            obj.onSuccess(res);
          }
        },
        onError: function (res) {
          if (isFunction(obj.onError)) {
            obj.onError(res);
          }
        },
        type: "JSON",
      });
    };

    Add = function (obj) {
      Request.Post({
        url: Routes.add,
        data: obj.data,
        onSuccess: function (res) {
          onCartUpdate(res, "add");
          if (isFunction(obj.onSuccess)) {
            obj.onSuccess(res);
          }
        },
        onError: function (res) {
          onCartUpdate(res, "add");
          if (isFunction(obj.onError)) {
            obj.onError(res);
          }
        },
      });
    };

    Update = function (obj) {
      Request.Post({
        url: Routes.update,
        data: obj.data,
        onSuccess: function (res) {
          onCartUpdate(res, "update");
          if (isFunction(obj.onSuccess)) {
            obj.onSuccess(res);
          }
        },
        onError: function (res) {
          onCartUpdate(res, "update");
          if (isFunction(obj.onError)) {
            obj.onError(res);
          }
        },
      });
    };

    Clear = function (obj) {
      Request.Post({
        url: Routes.clear,
        onSuccess: function (res) {
          onCartUpdate(res, "clear");
          if (obj) {
            if (isFunction(obj.onSuccess)) {
              obj.onSuccess(res);
            }
          }
        },
        onError: function (res) {
          onCartUpdate(res, "clear");
          if (obj) {
            if (isFunction(obj.onError)) {
              obj.onError(res);
            }
          }
        },
      });
    };

    Remove = function (obj) {
      var data = {
        updates: { [obj.id]: 0 },
      };
      Update({ data: data, onSuccess: obj.onSuccess });
    };

    Change = function (obj) {
      Request.Post({
        url: Routes.change,
        data: obj.data,
        onSuccess: function (res) {
          onCartUpdate(res, "change");
          if (isFunction(obj.onSuccess)) {
            obj.onSuccess(res);
          }
        },
        onError: function (res) {
          onCartUpdate(res, "change");
          if (isFunction(obj.onError)) {
            obj.onError(res);
          }
        },
      });
    };

    var onCartUpdate = function (res, action) {
      console.warn(action);
      console.log(res);
      
      updateCartCount();
    };
    

    var updateCartCount = function() {
      var CountList = document.querySelectorAll('[data-cart-count]');

      if (CountList.length > 0) {
        Get({
          onSuccess: function(r) {
            CountList.forEach(function(item) {
              item.innerText = r.item_count;              
            });
          }
        });        
      }
    }

    return {
      Add: Add,
      Update: Update,
      Get: Get,
      Remove: Remove,
      Clear: Clear,
      Change: Change,
    };
  })();
}

if (typeof WDN._Storage === "undefined") {
  WDN._Storage = (function () {
    var Config = {
      local: "localstorage",
      session: "session",
    };

    var Constructor = function (cookie, config, cookieConfig) {
      this.cookie = cookie;
      this.config = config || false;
      this.cookieConfig = cookieConfig || {};
      this.memory = [];
      this.storageType = cookieConfig.type || false;
      
      // Callback
      // Provided by config obj (optional)
      this._onCookieChange = function (eventName) {
          if (cookieConfig._onCookieChange) {
            cookieConfig._onCookieChange.call(this, eventName);
          }
      };

      this._found = function (handle) {
        return !!this._findItem(handle);
      };

      this._findIndex = function (handle) {
        if (
          this.storageType == Config.local ||
          this.storageType == Config.session
        ) {
          this.memory = JSON.parse(this.read());
        } else {
          this.memory = this.read();
        }
        return this.memory
          .map(function (item, index) {
            if (item.handle == handle) {
              return index;
            }
          })
          .filter(function (_item) {
            if (_item !== undefined) {
              return true;
            }
          })[0];
      };
      this._findItem = function (handle) {
        if (
          this.storageType == Config.local ||
          this.storageType == Config.session
        ) {
          this.memory = JSON.parse(this.read());
        } else {
          this.memory = this.read();
        }
        return this.memory.filter(function (item) {
          if (item.handle === handle) {
            return item;
          }
        })[0];
      };

      // Actual add function
      this._add = function (obj, eventName) {
        this.memory.push(obj);
        Cookies.set(this.cookie, this.memory, this.cookieConfig);
        this._onCookieChange(eventName);
      };

      this.add = function (obj) {
        if (
          this.storageType == Config.local ||
          this.storageType == Config.session
        ) {
          this.memory = this.readStorage(true);
        } else {
          this.memory = this.read(true);
        }

        // If already found
        if (this._found(obj.handle)) {
          // Add duplicate if config tells us to
          if (this.config) {
            if (this.config.duplicate) {
              this._add(obj, "updated");
            }
          }
        } else {
          this._add(obj, "added");
        }
      };

      this.remove = function (handle) {
        this.memory = this.read();
        if (this._found(handle)) {
          var foundIndex = this._findIndex(handle);
          this.memory.splice(foundIndex, 1);

          Cookies.set(this.cookie, this.memory, this.cookieConfig);
          this._onCookieChange("removed");
        }
      };

      this.read = function (no_event) {
        if (!no_event) {
          this._onCookieChange("read");
        }
        return Cookies.getJSON(this.cookie);
      };

      this.count = function () {
        return this.read().length;
      };

      this.clear = function () {
        Cookies.delete(this.cookie);
        this._onCookieChange("cleared");
      };

      this.clearStorage = function () {
        if (this.storageType == Config.local) {
          localStorage.removeItem(this.cookie);
        } else {
          sessionStorage.removeItem(this.cookie);
        }
      };

      this.readStorage = function () {
        if (this.storageType == Config.local) {
          return localStorage.getItem(this.cookie);
        } else {
          return sessionStorage.getItem(this.cookie);
        }
      };

      this.setEmptyStorage = function () {
        if (this.storageType == Config.session) {
          sessionStorage.setItem(this.cookie, "[]");
        } else {
          localStorage.setItem(this.cookie, "[]");
        }
      };

      this._addStorageItem = function (obj, eventName) {
        this.memory.push(obj);
        if (this.storageType == Config.session) {
          sessionStorage.setItem(this.cookie, JSON.stringify(this.memory));
        } else {
          localStorage.setItem(this.cookie, JSON.stringify(this.memory));
        }
        this._onCookieChange(eventName);
      };

      this._removeStorageItem = function (handle) {
        this.memory = JSON.parse(this.read());
        if (this._found(handle)) {
          var foundIndex = this._findIndex(handle);
          this.memory.splice(foundIndex, 1);
          if (this.storageType == Config.session) {
            sessionStorage.setItem(this.cookie, JSON.stringify(this.memory));
          } else {
            localStorage.setItem(this.cookie, JSON.stringify(this.memory));
          }
          this._onCookieChange("removed");
        }
      };

      this.setStorageType = function () {
        if (
          this.storageType == Config.local ||
          this.storageType == Config.session
        ) {
          this.remove = this._removeStorageItem;
          this._add = this._addStorageItem;
          this.storeEmptyData = this.setEmptyStorage;
          this.read = this.readStorage;
          this.clear = this.clearStorage;
        }
      };

      this.storeEmptyData = function () {
        Cookies.set(this.cookie, [], this.cookieConfig);
      };

      this.init = function () {
        this.setStorageType();
        if (!this.read(true)) {
          this.storeEmptyData();
        }
      };

      this.init();
    };

    return {
      Constructor: Constructor,
    };
  })();
}

if (typeof WDN.State === "undefined") {
  WDN.State = (function () {
    var config = {
      open: "open",
      closed: "closed",
    };
    return {
      open: function () {
        this.dataset.state = config.open;
      },
      close: function () {
        this.dataset.state = config.closed;
      },
      get: function () {
        return this.dataset.state;
      },
    };
  })();
}

if (typeof WDN.Select === "undefined") {
  WDN.Select = (function () {
    var State = WDN.State;
    var Select;

    // Glob list to hold our selects on page
    var List = {};
    var Create;

    var Config = {
      select: "Select",
      active: "Select__option--active",
      label: "Select__label",
      option: "Select__option",
      trigger: "Select__trigger",
      current_label: "[data-current-label]",
    };

    // Factory function
    Select = function (id) {
      this.id = id;
      var _this = this;

      this.selectors = {
        body: `body`,
        select: `.${Config.select}[data-id='${this.id}']`,
        options: `.${Config.select}[data-id='${this.id}'] .${Config.option}`,
        trigger: `.${Config.select}[data-id='${this.id}'] .${Config.trigger}`,
        label: `.${Config.select}[data-id='${this.id}'] .${Config.label}`,
        current_label: `.${Config.select}[data-id='${this.id}'] ${Config.current_label}`,
      };

      // Cache nodes
      this.nodes = {
        body: document.querySelector(this.selectors.body),
        select: document.querySelector(this.selectors.select),
        options: document.querySelectorAll(this.selectors.options),
        trigger: document.querySelector(this.selectors.trigger),
        label: document.querySelectorAll(this.selectors.label),
        current_label: document.querySelector(this.selectors.current_label),
      };

      this.target = this.nodes.select;

      this.currentOption = {};
      this.allOptions = {};

      // Build all options
      Array.from(this.nodes.options).map(function (option) {
        var obj = {
          label: option.innerText.trim(),
          value: option.dataset.value,
        };

        _this.allOptions[obj.value] = obj;
      });

      var Values = Array.from(this.nodes.options).map(function (elem) {
        return elem.dataset.value;
      });

      // Setup intial state

      var InitialActive = this.nodes.select.querySelector(`.${Config.active}`);
      this.currentOption = this.allOptions[InitialActive.dataset.value];
      this.value = this.currentOption.value;
      this.nodes.current_label.innerText = this.currentOption.label;

      // Select DOM element
      this.setActive = function (option) {
        // Deselect previous value
        var prevActive = this.nodes.select.querySelector(`.${Config.active}`);
        prevActive.classList.remove(Config.active);
        
        this.updateCurrent(option);
        option.classList.add(Config.active);
      };

      this.updateCurrent = function (option) {
        var item = this.nodes.trigger;
        item.querySelector(
          this.selectors.label
        ).innerText = this.currentOption.label;
        item.dataset.value = this.currentOption.value;
      };

      this.isValidOption = function (value) {
        if (Values.indexOf(value) > -1) {
          return true;
        }
      };

      this.update = function (value) {
        // Close only if interacted by user
        if (event) {
          this.close();
        }

        // Check if we were provided a valid option value
        // Check if the value is not already selected

        if (this.isValidOption(value) && this.value !== value) {
          // Find our selected option based on value parameter
          var option = this.target.querySelector(
            `.${Config.option}[data-value="${value}"]`
          );

          // Update interal value of select
          this.currentOption = this.allOptions[value];
          this.value = this.currentOption.value;

          // Update DOM
          this.setActive(option);

          // If a callback was provided, lets call it
          if (this.callback) {
            this.callback.call(this);
          }
        }
      };

      // Event listener functions
      this.onBlur = function () {
        this.close();
      };

      this.onEscape = function () {
        if (event.keyCode == 27) {
          this.close();
        }
      };

      // Named functions, to add / remove
      this.onBlurWrap = this.onBlur.bind(this);
      this.onEscapeWrap = this.onEscape.bind(this);

      // Short hand functions to add / remove
      this.addListeners = function () {
        this.target.focus();
        this.target.addEventListener("blur", this.onBlurWrap);
        window.addEventListener("keyup", this.onEscapeWrap);
      };

      this.removeListeners = function () {
        this.target.removeEventListener("blur", this.onBlurWrap);
        window.removeEventListener("keyup", this.onEscapeWrap);
      };

      // Register clicks on open/close Select
      this.nodes.trigger.addEventListener("click", this.toggle.bind(this));

      // Register clicks on Select options
      this.nodes.options.forEach(function (option) {
        option.addEventListener("click", function () {
          _this.update(option.dataset.value);
        });
      });
    };

    Select.prototype.open = function () {
      State.open.call(this.target);
      this.addListeners();
    };

    Select.prototype.close = function () {
      State.close.call(this.target);
      this.removeListeners();
    };

    Select.prototype.state = function () {
      return State.get.call(this.target);
    };

    Select.prototype.toggle = function () {
      if (this.state() === "closed") {
        this.open();
      } else {
        this.close();
      }
    };

    Create = function (id) {
      if (
        !List[id] &&
        id &&
        document.querySelector(`.${Config.select}[data-id='${id}']`)
      ) {
        List[id] = new Select(id);
      } else {
        console.warn(`Failed to init new Select with ID: "${id}".`);
      }
    };

    var Init = function () {
      document.querySelectorAll(`.${Config.select}`).forEach(function (select) {
        if (select.dataset.id) {
          Create(select.dataset.id);
        }
      });
    };

    return {
      Create: Create,
      List: List,
      Init: Init,
    };
  })();
}

WDN.Select.Init();

if (typeof WDN.Drawer === 'undefined') {
  WDN.Drawer = (function () {
    // Public available?
    var List, Init;

    // Private var
    var Config, Body;

    Body = document.querySelector('body');

    // List to hold generated objects, to allow access in global scope
    List = {};

    Config = {
      link: 'Drawer__link',
      bodyOpen: 'Drawer--open',
      drawer: 'Drawer',
      close: 'Drawer__close-icon',
      openVertical: 'Drawer--open-vertical',
      openHorizontal: 'Drawer--open-horizontal',
      state: {
        opened: 'opened',
        closed: 'closed',
      },
    };

    var Drawers = document.querySelectorAll(`.${Config.drawer}`);

    var Constructor = function (id) {
      this.id = id;
      this.drawer = document.querySelector(
        `.${Config.drawer}[data-id='${id}']`
      );
      this.links = document.querySelectorAll(
        `.${Config.link}[data-id='${id}']`
      );

      this.state = Config.state.closed;
      this.findAnimation();
      this.closeIcon = this.drawer.querySelector(`.${Config.close}`);
      this.eventHandler();

      this.closeOnKey = function () {
        // 27 = ESC
        if (event.keyCode == 27) {
          this.close();
        }
      };

      this.closeOnClick = function () {
        if (event.target.classList.contains(Config.bodyOpen)) {
          this.close();
        }
      };

      this.closeOnKeyBound = this.closeOnKey.bind(this);

      this.closeOnClickBound = this.closeOnClick.bind(this);
    };

    // Rename this pls
    Constructor.prototype.eventHandler = function () {
      this.bindClosers();
      this.bindOpeners();
    };

    Constructor.prototype.bindClosers = function () {
      this.closeIcon.addEventListener('click', this.close.bind(this));
    };

    Constructor.prototype.bindOpeners = function () {
      if (this.links.length > 0) {
        this.links.forEach(function (link) {
          link.addEventListener('click', this.open.bind(this));
        }, this);
      }
    };

    Constructor.prototype._addEvent = function (event, func) {
      return window.addEventListener(event, func);
    };

    Constructor.prototype._removeEvent = function (event, func) {
      return window.removeEventListener(event, func);
    };

    // State updater things
    Constructor.prototype._stateOnUpdate = function () {
      if (this.state === Config.state.closed) {
        this.drawer.removeAttribute('data-open');
      } else {
        this.drawer.setAttribute('data-open', '');
      }
      this.drawer.classList.toggle(this.currentAnimation);
      Body.classList.toggle(Config.bodyOpen);
    };

    Constructor.prototype.findAnimation = function () {
      switch (this.drawer.dataset.animate) {
        case 'top':
        case 'bottom':
          this.currentAnimation = Config.openVertical;
          break;
        case 'left':
          this.currentAnimation = Config.openHorizontal;
          break;
        default:
          this.currentAnimation = Config.openHorizontal;
      }
    };

    Constructor.prototype.bindEvents = function () {
      this._addEvent('keydown', this.closeOnKeyBound);
      this._addEvent('click', this.closeOnClickBound);
    };

    Constructor.prototype.removeEvents = function () {
      this._removeEvent('keydown', this.closeOnKeyBound);
      this._removeEvent('click', this.closeOnClickBound);
    };

    Constructor.prototype.stateUpdate = function (state) {
      this.state = state;
      this._stateOnUpdate();
    };

    Constructor.prototype.stateGet = function () {
      return this.state;
    };

    Constructor.prototype.onOpen = function () {
      if (this.callbacks) {
        if (this.callbacks.onOpen) {
          this.callbacks.onOpen.call(this);
        }
      }
    };

    Constructor.prototype.onClose = function () {
      if (this.callbacks) {
        if (this.callbacks.onClose) {
          this.callbacks.onClose.call(this);
        }
      }
    };

    // ### Open ###
    Constructor.prototype.open = function () {
      this.stateUpdate(Config.state.opened);
      this.bindEvents();
      this.onOpen();
    };

    // ### CLOSE ###
    Constructor.prototype.close = function () {
      this.stateUpdate(Config.state.closed);
      this.removeEvents();
      // Checking if callback exists
      this.onClose();
    };

    var Create = function (id) {
      var Obj = new Constructor(id);
      List[id] = Obj;
    };

    if (Drawers.length > 0) {
      var Init = function () {
        Drawers.forEach(function (Drawer) {
          if (typeof Drawer.dataset.id !== 'undefined') {
            Create(Drawer.dataset.id);
          }
        });
      };
      // Auto setup
      Init();
    }

    return {
      List: List,
    };
  })();
}

if (typeof WDN.MegaMenu === 'undefined') {
  WDN.MegaMenu = (function () {
    
    var Names = {
      link: '[data-link-megamenu-image]',
      previewOutput: '[data-megamenu-image-output]',
      previewItem: '[data-megamenu-preview-item]',
    };

    var Nodes = {
      link: document.querySelectorAll(Names.link),
      previewOutput: document.querySelector(Names.previewOutput),
    };

    var Init, Link, HidePreviewItems;
    var Links = {};

    Link = function (handle) {
      this.handle = handle;
      this.link = document.querySelector(Names.link + "[data-handle='" + handle + "']");
      this.previewItem = false;
      this.bind();
    };

    Link.prototype.bind = function () {
      this.link.addEventListener('mouseover', this.linkOnHover.bind(this));
    };

    Link.prototype.linkOnHover = function () {
      if (this.previewItem) {
        HidePreviewItems();
        this.displayPreviewItem();
      } else {
        this.renderPreview();
      }
    };

    Link.prototype.renderPreview = function () {
      var url = '/collections/' + this.handle + '?view=megamenu';
      WDN.Request.Get({
        url: url,
        onSuccess: function (res) {
          HidePreviewItems();
          Nodes.previewOutput.insertAdjacentHTML('beforeend', res);
          this.assignPreviewItem();
        }.bind(this),
        onError: function (res) {
          console.log('error');
        },
      });
    };

    Link.prototype.assignPreviewItem = function () {
      this.previewItem = document.querySelector(
        Names.previewItem + "[data-handle='" + this.handle + "']"
      );
    };

    Link.prototype.displayPreviewItem = function () {
      this.previewItem.removeAttribute('data-hidden');
    };

    HidePreviewItems = function () {
      var Items = document.querySelectorAll(Names.previewItem);
      if (Items.length > 0) {
        Items.forEach(function (item) {
          item.setAttribute('data-hidden', '');
        });
      }
    };

    Init = function () {
      if (Nodes.link.length > 0) {
        Nodes.link.forEach(function (link) {
          newLink = new Link(link.dataset.handle);
          Links[link.dataset.handle] = newLink;
        });
      }
    };

    Init();
    return {};
  })();
}

if (typeof WDN.MegaMenuChildrenPosters === 'undefined') {
  WDN.MegaMenuChildrenPosters = (function () {
    
    var Names = {
      link: '[data-link-megamenu-child-image]',
      previewOutput: '[data-megamenu-child-image-output]',
      previewItem: '[data-megamenu-preview-item]',
    };

    var Nodes = {
      link: document.querySelectorAll(Names.link),
      previewOutput: document.querySelector(Names.previewOutput),
    };

    var Init, Link, HidePreviewItems;
    var Links = {};

    Link = function (handle) {
      this.handle = handle;
      this.link = document.querySelector(Names.link + "[data-handle='" + handle + "']");
      this.previewItem = false;
      this.bind();
    };

    Link.prototype.bind = function () {
      this.link.addEventListener('mouseover', this.linkOnHover.bind(this));
    };

    Link.prototype.linkOnHover = function () {
      if (this.previewItem) {
        HidePreviewItems();
        this.displayPreviewItem();
      } else {
        this.renderPreview();
      }
    };

    Link.prototype.renderPreview = function () {
      var url = '/collections/' + this.handle + '?view=megamenu';
      WDN.Request.Get({
        url: url,
        onSuccess: function (res) {
          HidePreviewItems();
          Nodes.previewOutput.insertAdjacentHTML('beforeend', res);
          this.assignPreviewItem();
        }.bind(this),
        onError: function (res) {
          console.log('error');
        },
      });
    };

    Link.prototype.assignPreviewItem = function () {
      this.previewItem = document.querySelector(
        Names.previewItem + "[data-handle='" + this.handle + "']"
      );
    };

    Link.prototype.displayPreviewItem = function () {
      this.previewItem.removeAttribute('data-hidden');
    };

    HidePreviewItems = function () {
      var Items = document.querySelectorAll(Names.previewItem);
      if (Items.length > 0) {
        Items.forEach(function (item) {
          item.setAttribute('data-hidden', '');
        });
      }
    };

    Init = function () {
      if (Nodes.link.length > 0) {
        Nodes.link.forEach(function (link) {
          newLink = new Link(link.dataset.handle);
          Links[link.dataset.handle] = newLink;
        });
      }
    };

    Init();
    return {};
  })();
}

  
if (typeof WDN.WishlistIcon === 'undefined') {
  WDN.WishlistIcon = (function () {
    var Names = {
      icon: 'Wishlist-icon',
    };

    var Selectors = {
      icon: `.${Names.icon}`,
    };

    var Nodes = {
      icon: document.querySelectorAll(`${Selectors.icon}`),
    };

    var List = {};

    var Create, Constructor;

    var Storage = new WDN._Storage.Constructor(
      'Wishlist', // Storage name
      {},
      {
        expires: 7
      }
    );

    Constructor = function (handle) {
      this.handle = handle;
      this.icon = document.querySelector(
        `${Selectors.icon}[data-handle="${handle}"]`
      );

      this.init();
    };

    Constructor.prototype.init = function () {
      this.addIconState();
      this.bind();
    };

    Constructor.prototype.addIconState = function () {
      if (this.isStored(this.handle)) {
        this.wishlistedState();
      }
    };

    Constructor.prototype.bind = function () {
      this.icon.addEventListener('click', this.clickHandler.bind(this));
    };

    Constructor.prototype.wishlistedState = function () {
      this.icon.setAttribute('data-wishlisted', '');
    };

    Constructor.prototype.clearState = function () {
      this.icon.removeAttribute('data-wishlisted');
    };

    Constructor.prototype.clickHandler = function () {
      if (!this.isStored(this.handle)) {
        Storage.add({ handle: this.handle });
        WDN.Tracking.add_to_wishlist();
        this.wishlistedState();
      } else {
        Storage.remove('' + this.handle);
        this.clearState();
      }
    };

    Constructor.prototype.isStored = function (handle) {
      return Storage._findIndex(handle) > -1;
    };

    Create = function () {
      if (Nodes.icon.length > 0) {
        Nodes.icon.forEach(function (icon) {
          var newObj = new Constructor(icon.dataset.handle);
          List[icon.dataset.handle] = newObj;
        });
      }
    };

    Create();
    

    return {
      Storage: Storage,
    };
  })();
}

// Old WDN.Wishlist


if (typeof WDN.PosterWishlist === "undefined") {
  WDN.PosterWishlist = (function () {
    var Names = {
      posterSelect: "Variant__select",
      frameSelect: "Frame__select",
      heartIcon: "Product__wishlist-icon",
      posterScript: "Select__product-script",
      frameScript: "Product__frames-script",
      mainWrapper: "Product__items-wrapper",
    };
    var Selectors = {
      posterSelect: `.${Names.posterSelect}`,
      frameSelect: `.${Names.frameSelect}`,
      heartIcon: `.${Names.heartIcon}`,
      posterScript: `.${Names.posterScript}`,
      frameScript: `.${Names.frameScript}`,
      mainWrapper: `.${Names.mainWrapper}`,
    };
    var Nodes = {
      posterSelect: document.querySelector(Selectors.posterSelect),
      frameSelect: document.querySelector(Selectors.frameSelect),
      heartIcon: document.querySelectorAll(Selectors.heartIcon),
      posterScript: document.querySelector(Selectors.posterScript),
      frameScript: document.querySelector(Selectors.frameScript),
      mainWrapper: document.querySelector(Selectors.mainWrapper),
    };

    var Init, Bind, PosterHandler, FrameHandler;
    var IsWishlisted, InitSelect;

    var Icon = {};
    var Hearts = {};

    var updateWishlistCount = function() {
      var targets = document.querySelectorAll('[data-wishlist-count]'); 

      if (targets.length > 0) {
        var count = JSON.parse(Storage.read()).length;

        targets.forEach(function(element) {
          element.innerText = count;
          if (count == 0) {
            element.classList.remove('WishlistIcon--empty');
          } else {
            element.classList.add('WishlistIcon--empty');
          }
        });
      }
    }

    var Storage = new WDN._Storage.Constructor(
      "Wishlist", // Storage name
      {},
      {
        type: "localstorage",
        _onCookieChange: function(eventName) {
          if (eventName != 'read') {
            updateWishlistCount(); 
          }
        }
      }
    );

    Icon.setWishlisted = function (handle) {
      var Icon = document.querySelector(`${Selectors.heartIcon}[data-handle="${handle}"]`);
      Icon.setAttribute("data-wishlisted", "");
    };

    Icon.removeWishlisted = function (handle) {
      var Icon = document.querySelector(`${Selectors.heartIcon}[data-handle="${handle}"]`);
      Icon.removeAttribute("data-wishlisted", "");
    };

    Bind = function () {
      if (Nodes.posterSelect) {
        Nodes.posterSelect.addEventListener("change", PosterHandler);
      }
      if (Nodes.frameSelect) {
        Nodes.frameSelect.addEventListener("change", FrameHandler);
      }
      
      Nodes.heartIcon = document.querySelectorAll(Selectors.heartIcon);
      
      if (Nodes.heartIcon.length > 0) {
        Nodes.heartIcon.forEach(function (icon) {
          if (Hearts[icon.dataset.handle] === undefined) {
            var newHeart = new Heart(icon.dataset.handle);
            Hearts[icon.dataset.handle] = newHeart;            
          }
        });
      }
    };

    var Heart = function (handle) {
      this.handle = handle;
      this.icon = document.querySelector(`${Selectors.heartIcon}[data-handle="${this.handle}"]`);
      this.iconList = document.querySelectorAll(`${Selectors.heartIcon}[data-handle="${this.handle}"]`);
      
      this.type = this.icon.dataset.type;
      this.firstVariant = this.icon.dataset.firstvar;
      this.scriptSrc = document.querySelector(`${Selectors.posterScript}[data-handle="${this.handle}"]`);
      
      if (this.scriptSrc) {
        this.posterProduct = JSON.parse(this.scriptSrc.innerText);
        this.posterProduct = this.posterProduct[0];
      }
      
      if (this.posterProduct && this.posterProduct.variants) {
        this.variants = this.posterProduct.variants;
        this.prodId = this.posterProduct.prodId;
        this.id = this.posterProduct.id;
      } else {
        this.variants = [];
        this.posterProduct = {};
        this.posterProduct.id = parseInt(this.icon.dataset.variantId);
        this.posterProduct.prodId = this.icon.dataset.productId;
        
        this.prodId = this.icon.dataset.productId;
        this.id = parseInt(this.icon.dataset.variantId);
      }
      
      this.setState();
      this.bind();
    };

    Heart.prototype.bind = function () {
      this.iconList.forEach(function(item) {
      item.addEventListener("click", this.addHandler.bind(this));
      }, this);
    };

    Heart.prototype.addHandler = function () {
      var SelectedPoster = WDN.Select.List.Størrelse ? WDN.Select.List.Størrelse.value : this.firstVariant;
      var Postervariant = this.getPosterByTitle(SelectedPoster);
      var Framevariant = this.getFrameByTitle(SelectedPoster);
      
      if (this.scriptSrc) {
        this.posterProduct = JSON.parse(this.scriptSrc.innerText);
        this.frameId = (this.posterProduct[0].frame.id).toString();
      }

      this.validateCurrentWishlist(Postervariant, Framevariant);
    };

    Heart.prototype.getPosterByTitle = function (title) {
      var Found = false;
      var PosterVariants = this.variants;
      for (var key in PosterVariants) {
        if (PosterVariants.hasOwnProperty(key)) {
          if (PosterVariants[key].title == title) {
            Found = PosterVariants[key];
          }
        }
        if (Found) {
          break;
        }
      }
      return Found;
    };

    Heart.prototype.getFrameByTitle = function (title) {
      if (typeof FrameVariants === "undefined") {
        var product = false;
      } else {
        var product = FrameVariants[WDN.Select.List.frameDropdown.value];
      }
      var variant = false;
      if (product) {
        variant = product.variants[title];
      }
      return variant;
    };

    Heart.prototype.validateCurrentWishlist = function (Postervariant, Framevariant) {
      var data = this.formatData(Postervariant, Framevariant);
      var handle = this.handle;
      
      if (this.posterProduct && this.posterProduct.handle) {
        handle = this.posterProduct.handle;
      }
      
      if (IsWishlisted(handle)) {
        Storage.remove(handle);
      } else {
        WDN.Tracking.add_to_wishlist();
        Storage.add(data);
      }
      this.setState();
    };

    Heart.prototype.formatData = function (poster, frame) {
      var frameId = frame ? frame.id : false;
      
      var Formatted = {
        id: poster.id || this.id,
        prodId: this.posterProduct.prodId || this.prodId,
        handle: this.handle,
        type: this.type,
        frame: {
          id: this.frameId,
        },
      };
      return Formatted;
    };

    Heart.prototype.setState = function () {
      var handle = this.handle;

      if (this.posterProduct && this.posterProduct.handle) {
        handle = this.posterProduct.handle;
      }
      
      if (IsWishlisted(handle)) {
        this.setWishlisted();
      } else {
        this.removeWishlisted();
      }
    };
    
    Heart.prototype.setWishlisted = function () {
      this.iconList.forEach(function(item) {
         item.setAttribute("data-wishlisted", "");
      }, this);
    };

    Heart.prototype.removeWishlisted = function () {
      this.iconList.forEach(function(item) {
        item.removeAttribute("data-wishlisted", "");
      }, this);
    };

    var FormatData = function (handle, type, poster, frame) {
      var frameId = frame ? frame.id : false;
      var Formatted = {
        id: poster.id,
        prodId: this.prodId,
        handle: handle,
        type: type,
        frame: {
          id: frameId,
        },
      };
      return Formatted;
    };

    IsWishlisted = function (handle) {
      var Current = JSON.parse(Storage.read());
      
      // Return false if no items in wishlist
      if (Current.length == 0) {
        return false;
      }
      
      var found = Current.filter(function(item) {
        if (item.handle == handle) {
          return true; 
        }
      });
      
      return !!found.length;
    };
    

    Init = function () {
      if (Nodes.mainWrapper) {
        InitSelect();
      }
      
      updateWishlistCount();
      Bind();
    };

    InitSelect = function () {
      WDN.Select.Init();
      WDN.Product_select.Init({
        // runs on load and returns selected variant
        onLoad: function (variant) {
          // console.log(variant);
        },
        // runs on change and returns selected variant
        onChange: function (variant) {},
      });

      WDN.Select.List.frameDropdown.callback = function () {
        // callback for frame dropdown
      };
    };

    Init();

    return { 
      Storage: Storage,
      Bind: Bind,
      FormatData: FormatData
    };
  })();
}

if (typeof WDN.WishlistRender === 'undefined') {
  WDN.WishlistRender = (function () {
    var Names = {
      wishlistOutput: 'Poster__wishlist-container--inner',
      wishlistItem: 'Wishlist__grid-item',
      wishlistAdd: 'Wishlist__grid--add',
      wishlistHeart: '[data-wishlisted]',
      wishlistInput: 'Wishlist__grid-input',
      wishlistDecrease: 'Wishlist__grid-quantity--decrease',
      wishlistIncrease: 'Wishlist__grid-quantity--increase',
      wishlistItemPrice: 'Wishlist__grid-item--price',
      wishlistTotalPrice: 'Poster__wishlist-total--price',
      wishlistAddCollection: 'Poster__wishlist-total',
      wishlistEmpty: 'Wishlist-title--empty',
    };

    var Selectors = {
      wishlistOutput: `.${Names.wishlistOutput}`,
      wishlistItem: `.${Names.wishlistItem}`,
      wishlistAdd: `.${Names.wishlistAdd}`,
      wishlistHeart: `${Names.wishlistHeart}`,
      wishlistInput: `.${Names.wishlistInput}`,
      wishlistDecrease: `.${Names.wishlistDecrease}`,
      wishlistIncrease: `.${Names.wishlistIncrease}`,
      wishlistItemPrice: `.${Names.wishlistItemPrice}`,
      wishlistTotalPrice: `.${Names.wishlistTotalPrice}`,
      wishlistAddCollection: `.${Names.wishlistAddCollection}`,
      wishlistEmpty: `.${Names.wishlistEmpty}`,
    };

    var Nodes = {
      wishlistOutput: document.querySelector(Selectors.wishlistOutput),
      wishlistEmpty: document.querySelector(Selectors.wishlistEmpty),
      wishlistTotalPrice: document.querySelector(Selectors.wishlistTotalPrice),
      wishlistAddCollection: document.querySelector(
        Selectors.wishlistAddCollection
      ),
    };

    var Init, Render, SendRequest, addCollectionHandler;
    var Poster, UpdateTotalPrice, Bind, CreateInstance;

    var List = {};

    var Wishlist = JSON.parse(WDN.PosterWishlist.Storage.readStorage());

    Render = function () {
      var Ids = [];
      var Current = JSON.parse(WDN.PosterWishlist.Storage.readStorage());
      
      for (var key in Current) {
        if (Current.hasOwnProperty(key)) {
          if (Ids.indexOf(Current[key].prodId) == -1) {
            Ids.push(Current[key].prodId);
          }
        }
      }
      
      SendRequest(Ids);
    };

    SendRequest = function (ids) {
      var idParams = ids.reverse().join('%20OR%20id:');
      
      if (idParams.length == 0) {
        idParams = 1;
      }
      
      var urlPrefix = '';
      
      if (Shopify.locale != 'en') {
		urlPrefix = '/' + Shopify.locale;
      }
        
      var url = urlPrefix + '/search?view=wishlist_search&type=product&q=id:' + idParams;
      WDN.Request.Get({
        url: url,
        onSuccess: function (res) {
          Nodes.wishlistOutput.innerHTML = res;
          WDN.Select.Init();
          CreateInstance();
        },
        onError: function (res) {
          // error callback
        },
      });
    };

    Poster = function (handle) {
      this.handle = handle;
      this.item = document.querySelector(
        `${Selectors.wishlistItem}[data-handle="${handle}"]`
      );
      this.prodId = this.item.dataset.prodid;
      this.addToCart = this.item.querySelector(Selectors.wishlistAdd);
      this.heart = this.item.querySelector(Selectors.wishlistHeart);
      this.type = this.item.dataset.type;
      this.variantSelect = WDN.Select.List[handle];
      this.frameSelect = WDN.Select.List[handle + '_frame'];
      
      this.quantityInput = this.item.querySelector(Selectors.wishlistInput);
      this.decrease = this.item.querySelector(Selectors.wishlistDecrease);
      this.increase = this.item.querySelector(Selectors.wishlistIncrease);
      
      this.variants = JSON.parse(
        document.querySelector(`.Variants-script[data-handle="${handle}"]`)
          .innerText
      );
      
      this.priceContainer = this.item.querySelector(
        Selectors.wishlistItemPrice
      );
      
      this.price = 0;
      this.adjustVariantSelect();
      
      this.bind();
      
      this.displayMatchingFrames();
    };

    Poster.prototype.adjustVariantSelect = function () {
      var Wishlist = JSON.parse(WDN.PosterWishlist.Storage.readStorage());
      
      var wishlistProduct = Wishlist.filter((x) => x.handle === this.handle)[0];
      
      var selectedVariant = this.variants.filter(
        (x) => x.id === wishlistProduct.id
      )[0];

      this.assignIds(selectedVariant, wishlistProduct.frame);
      this.setActiveVariant(selectedVariant.option1);
      this.adjustFrameSelect(wishlistProduct.frame.id, selectedVariant);
    };

    Poster.prototype.adjustFrameSelect = function (frameId, Prod) {
      var Found = false;

      if (frameId && frameId != '0') {
        for (var key in FrameVariants) {
          if (Found) {
            break;
          }
          
          var iterationFrame = FrameVariants[key].variants[Prod.option1];

          if (FrameVariants.hasOwnProperty(key) && iterationFrame) {
            if (iterationFrame.id == frameId) {
              this.setActiveFrame(key);
              this.setFrameImg(iterationFrame);
              this.updatePrice(Prod, iterationFrame);
              Found = true;
            }
          }
          
        }
      } else {
        // poster without frame
        this.updatePrice(Prod, false);
      }
    };

    Poster.prototype.setActiveVariant = function (key) {
      var domOption = this.item.querySelector(`[data-option="${key}"]`);
      this.variantSelect.setActive(domOption);
      this.variantSelect.update(key);
    };

    Poster.prototype.setActiveFrame = function (key) {
      var domOption = this.item.querySelector(`[data-option="${key}"]`);
      this.frameSelect.setActive(domOption);
      this.frameSelect.update(key);
    };

    Poster.prototype.setFrameImg = function (frame) {
      var frameContainer = this.item.querySelector('.Wishlist__grid-frame');
      if (frame) {
        var itemType = this.item.dataset.type;
        var selectedFrame = frame.images[itemType];
        frameContainer.style.backgroundImage = `url(${selectedFrame})`;
      } else {
        // remove frame background
        frameContainer.style.backgroundImage = 'url()';
      }
    };

    Poster.prototype.bind = function () {
      this.bindQuantityControls();
      this.bindHeart();
      this.bindQuantityInput();

      this.variantSelect.callback = function () {
        this.SelectCallback();
        // updates frame dropdown list
        this.displayMatchingFrames();
      }.bind(this);

      this.frameSelect.callback = function () {
        this.SelectCallback();
      }.bind(this);

      this.addToCart.addEventListener(
        'click',
        this.addToCartCallback.bind(this)
      );
    };
    
    Poster.prototype.displayMatchingFrames = function () {
      var selectedSize = this.variantSelect.currentOption.value;
      
      this.displayAllOptions();
      var notMatching = [];
      
      for (frame in FrameVariants) {
        if (FrameVariants.hasOwnProperty(frame)) {
          // selecting variants for each size and filtering non matching sizes
          if (!FrameVariants[frame].variants[selectedSize]) {
            notMatching.push(frame);
          }
        }
      }

      this.hideNotMatchingOptions(notMatching);
    };

    Poster.prototype.displayAllOptions = function () {
      var options = this.frameSelect.nodes.options;
      if (options.length > 0) {
        options.forEach(function (option) {
          option.removeAttribute('data-hidden');
        });
      }
    };

    Poster.prototype.hideNotMatchingOptions = function (options) {
      if (options.length > 0) {
        options.forEach(function (option) {
          // finds non matching option in that specific frame select
          var extra = this.frameSelect.nodes.select.querySelector(
            `[data-option="${option}"]`
          );
          extra.setAttribute('data-hidden', '');
        }, this);
      }
    };

    Poster.prototype.bindQuantityInput = function () {
      this.quantityInput.addEventListener(
        'change',
        this.quantityOnChange.bind(this)
      );
    };

    Poster.prototype.quantityOnChange = function (e) {
      if (e.target.value < 1) {
        this.removeFromWishlist();
      } else {
        this.SelectCallback();
      }
    };

    Poster.prototype.addToCartCallback = function () {
      var data = [];
      var bundle_id = Math.ceil(Math.random() * 100000);

      var ProductObj = { id: this.variantId, quantity: this.quantityInput.value };

      ProductObj.properties = {};
      ProductObj.properties._origin = 'wishlist';



      if (this.frameId) {
        ProductObj.properties._bundle_id = bundle_id;
      }
      
      
      
      data.push(ProductObj);
      
      // if frame is selected, push it together with the poster
      if (this.frameId) {
        var FrameObj = { id: this.frameId, quantity: this.quantityInput.value, properties: { '_bundle_id': bundle_id, _origin: 'wishlist' } };
        data.push(FrameObj);
      }
      
      
      WDN.Cart.Add({
        data: {
          items: data,
        },
        onSuccess: function (r) {
          if (typeof onAddToCart === 'function') {
            WDN.Tracking.add_to_cart_wishlist();
            onAddToCart(this, r, data);
          }
        }.bind(this),
        onError: function () {
        },
      });
    };

    Poster.prototype.SelectCallback = function () {
      var selectedValue = this.variantSelect.value;
      var selectedFrame = this.frameSelect.currentOption.value;
      var selectedVariant = this.variants.filter(
        (x) => x.option1 === selectedValue
      )[0];
      // if its not a placeholder( value = "" )
      if (selectedFrame !== '') {
        var foundFrame = FrameVariants[selectedFrame].variants[selectedValue];
        this.setFrameImg(foundFrame);
      } else {
        // if its placeholder frame is empty
        var foundFrame = { id: false, price: 0 };
        // will remove background frame since there is no frame
        this.setFrameImg();
      }
      this.assignIds(selectedVariant, foundFrame);
      this.updatePrice(selectedVariant, foundFrame);
      this.updateWishlist(selectedVariant, foundFrame);
      UpdateTotalPrice();
    };

    Poster.prototype.assignIds = function (variant, frame) {
      this.variantId = variant.id;
      this.frameId = frame ? frame.id : false;
    };

    Poster.prototype.updatePrice = function (variant, frame) {
      if (!frame) {
        // set the frame to placeholder value
        this.frameSelect.update('');
      }

      var framePrice = frame ? frame.price : 0;
      var sum = parseFloat(variant.price) + parseFloat(framePrice);
      this.price = sum * this.quantityInput.value;
      this.priceContainer.innerHTML = WDN.Money.Format(this.price);
    };

    Poster.prototype.updateWishlist = function (poster, frame) {
      var newData = WDN.PosterWishlist.FormatData(
        this.handle,
        this.type,
        poster,
        frame
      );
      
      newData.prodId = this.prodId;
      
      // deletes the current wishlist item
      WDN.PosterWishlist.Storage.remove(this.handle);
      
      // replaces it with new data
      WDN.PosterWishlist.Storage.add(newData);
    };

    Poster.prototype.bindHeart = function () {
      this.heart.addEventListener('click', this.removeFromWishlist.bind(this));
    };

    Poster.prototype.bindQuantityControls = function () {
      this.decrease.addEventListener(
        'click',
        this.quantityHandler.bind(this, -1)
      );
      this.increase.addEventListener(
        'click',
        this.quantityHandler.bind(this, +1)
      );
    };

    Poster.prototype.quantityHandler = function (nmr) {
      var value = parseFloat(this.quantityInput.value);
      var nextvalue = value + nmr;
      if (value > 0 && nextvalue > 0) {
        this.quantityInput.value = nextvalue;
      } else {
        this.quantityInput.value = nextvalue;
        this.removeFromWishlist();
      }
      // updating item and total price
      this.SelectCallback();
    };

    Poster.prototype.removeFromWishlist = function () {
      WDN.PosterWishlist.Storage.remove(this.handle);
      
      this.item.remove();
      delete List[this.handle];
      UpdateTotalPrice();
      
      if (Object.keys(List).length == 0) {
        Nodes.wishlistEmpty = document.querySelector(Selectors.wishlistEmpty);
        Nodes.wishlistEmpty.removeAttribute('data-hidden');
      }
    };

    UpdateTotalPrice = function () {
      var Sum = [];
      for (var key in List) {
        if (List.hasOwnProperty(key)) {
          Sum.push(List[key].price);
        }
      }
      // summing all array items which will give a total price
      var Total = Sum.reduce((a, b) => a + b, 0);
      Nodes.wishlistTotalPrice.innerHTML = WDN.Money.Format(Total);
    };

    CreateInstance = function () {
      var items = document.querySelectorAll(Selectors.wishlistItem);
      if (items.length > 0) {
        items.forEach(function (item) {
          var newObj = new Poster(item.dataset.handle);
          List[item.dataset.handle] = newObj;
        });
        UpdateTotalPrice();
      }
    };
    var onAddToCart = false;

    Init = function (callback) {
      if (Nodes.wishlistOutput) {
        Render();
        Bind();
        callback ? (onAddToCart = callback.onAddToCart) : '';
      }
    };

    Bind = function () {
      Nodes.wishlistAddCollection.addEventListener(
        'click',
        addCollectionHandler
      );
    };

    addCollectionHandler = function (e) {
      e.preventDefault();
      
      if (Object.keys(List).length > 0) {
        
        var Total = [];
        
        for (var key in List) {
          if (List.hasOwnProperty(key)) {
            var item = List[key];
            var id = item.variantId;
            var quantity = item.quantityInput.value;
            
            var bundle_id = Math.ceil(Math.random() * 100000);
            var ProductObj = { id: id, quantity: quantity };
            
            ProductObj.properties = {};
            ProductObj.properties._origin = 'wishlist';
            
            
            if (item.frameId && item.frameId != '0') {
              
              ProductObj.properties._bundle_id = bundle_id;
            }
                        
            Total.push(ProductObj);
         
            if (item.frameId && item.frameId != '0') {
              Total.push({ id: item.frameId, quantity: quantity, properties: { '_bundle_id': bundle_id, _origin: 'wishlist' } });
            }
          }
        }
        
        WDN.Cart.Add({
          data: {
            items: Total,
          },
          onSuccess: function (res) {
            if (typeof onAddToCart === 'function') {
              WDN.Tracking.add_to_cart_wishlist();
              onAddToCart(res);
            }
          },
          onError: function () {
            console.log('add to cart error');
          },
        });
      }
    };

    return {
      Init: Init,
    };
  })();
}

WDN.WishlistRender.Init({
  onAddToCart: function (elem, data) {
    document.dispatchEvent(new CustomEvent('product:added', {
      bubbles: false,
      detail: {
        variant: 1234, // random
        quantity: 1
      }
    }))
  },
});



(function() {
  var targ = $('.ShopSelector__sidebar-menu');
  
  if (targ) {
    targ.on('click', function() {
      $(".Drawer__Close").click();
    });
  }
  
})();



if (typeof WDN.VimeoPlayer === 'undefined') {
  WDN.VimeoPlayer = (function() {
    var VimeoVideos =  (function() {
      var body = document.querySelector('body');
      var videoList = document.querySelectorAll('[data-vid-id]');
      var List = [];

      var Config = {
        pc_min_width: 540
      }

      var ScreenWidth = window.innerWidth;

      if (typeof ScreenWidth != 'number') {
        ScreenWidth = 0; 
      }

      var Video = function(node) {
        this.node = node;
        this.wasLoaded = false;
        this.autoload = true;
        this.autoplay = true;
        this.dataset = this.node.dataset;
        this.videoConfig = {};
        this.id = this.dataset.vidId;

        this.name = this.dataset.videoName;
        this.videoConfig.id = this.dataset.vidId;

        if (this.dataset.videobg == '') {
          this.videoConfig.background = true;
        }

        if (this.dataset.autoload == 'false') {
          this.autoload = false; 
        }

        if (this.dataset.autoplay == 'false') {
          this.autoplay = false; 
        }

        if (this.dataset.pcOnly.length == 0) {
          if (ScreenWidth > Config.pc_min_width) {
            this.autoplay = true;
            this.autoload = true;
          } else {
            this.autoplay = false;
            this.autoload = false;
          }
        }


        if (this.autoload) {
          this.initVideo();
          this.listenForEvents();

          if (this.autoplay) {
            this.control('play');
          }
        }
      }

      Video.prototype.videoWasMountedSuccesfully = function() {
        if (this.name.length > 0) {
          var name = this.name;
          var id = this.id;
          var _event = new CustomEvent('vimeo:video:playing', { detail: { name: name, id: id }});
          body.dispatchEvent(_event);
        }
      };


      Video.prototype.load = function() {
        this.initVideo(); 
      }

      Video.prototype.control = function(action) {
        switch(action) {
          case "play":
            this.video.play();
            break;
          case "pause":
            this.video.pause();
            break;
        }
      }

      Video.prototype.initVideo = function() {
        if (!this.wasLoaded) {
          this.video = new Vimeo.Player(this.node, this.videoConfig);
          this.listenForEvents();
        }
      }

      Video.prototype.listenForEvents = function() {     
        this.videoWasMountedSuccesfully();
        this.wasLoaded = true;
      }

      var Init = function() {
        videoList.forEach(function(video) {
          var ins = new Video(video);
          List.push(ins);
        });
      }

      var scriptSrc = document.querySelector('[data-vimeo-script]');

      scriptSrc.onload = function(e) {
        Init();
      };

      if (videoList.length) {
        var scriptUrl = scriptSrc.dataset.src;
        scriptSrc.src = scriptUrl;
      }
      
      return {
        List: List,
        Init: Init
      }
    })();


    // Detect when collection video is playing
    (function() {
      var body = document.querySelector('body');

      body.addEventListener('vimeo:video:playing', function(e) {

        var id = e.detail.id;
        var name = e.detail.name;

        if (name == 'CollectionHeroVideo') {
          var target = document.querySelector('[data-video-wrapper="CollectionHeaderVideo"]');
          target.dataset.videoPlaying = 'true';
        }
        

        if (name == 'VideoIndexSection' && id) {
          var target = document.querySelector('.VideoIndexSection[data-id="' + id + '"]');
          target.dataset.videoPlaying = 'true';
        }

      });

    })();
  })();
}



WDN.ProductSimpleBundle = (function() {

  var bundleIdListElem = document.querySelector('[data-bundle-id-list]');

  if (!bundleIdListElem) {
    return false;
  }

  var seq = bundleIdListElem.content.split(',');

  var _getRandomNumber = function() {
    return Math.round((Math.random() * 10000));
  }

  var _buildReqItems = function(source) {
    var bundles = [];
    source.forEach(function(item, index) {
      if (index % 2 == 0) {
        var hash = _getRandomNumber();
        var item = { "id": seq[index + 1], quantity: 1, "properties": { "_bundle_id": hash }};
        var item2 = { "id": seq[index], quantity: 1, "properties": { "_bundle_id": hash }};

        bundles.push(item);
        bundles.push(item2);
      }
    });
    console.warn(bundles);
    return bundles;
  }

  var _addBundleToCart = function() {
    WDN.Cart.Add({
      data: {
        items: _buildReqItems(seq)
      },
      onSuccess: function () {
        document.dispatchEvent(new CustomEvent('product:added', {
          bubbles: false,
          detail: {
            variant: 1234,
            quantity: 1
          }
        }))
      },
      onError: function (e) {
        console.log(e);
      },
    });
  }

  var addBundleItem = document.querySelectorAll('[data-bundle-add]');


  addBundleItem.forEach(function(item) {
    item.addEventListener('click', _addBundleToCart);
  });

})();